module.exports = __webpack_public_path__ + "img/slide-4.1a2b3499.jpg";